<script>
	import axios from 'axios'
	import InstaSockpuppet from './components/InstaSockpuppet.svelte'
	import MessageSockpuppet from './components/MessageSockpuppet.svelte'

	const roby = axios.create({
		baseURL: 'https://oio.town',
		timeout: 50000,
		headers: {
			'Content-Type': 'application/json; charset=UTF-8'
		}
	})

	const noby = axios.create({
		baseURL: 'http://192.168.1.53:3344/', // change this during testing
		timeout: 50000,
		headers: {
			'Content-Type': 'application/json; charset=UTF-8'
		}
	})
</script>

<main>
	<InstaSockpuppet bot={roby}/>  
	<MessageSockpuppet bot={roby}/>  
</main>

<style>
	main {
		display: flex;
		flex-wrap: wrap;
		gap: 1.5rem;
		padding: 2rem;
	}
</style>